import * as React from "react";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Grid } from "../styles/MaterialUI";
import { useState } from "react";
import ScreenTable from "./dashboard/ScreenTable";
import ContentTable from "./dashboard/ContentTable";
import IntegrationList from "./OtherComponents/IntegrationList";
import { useSelector } from "react-redux";

const CustomTabs = () => {
  const [value, setValue] = useState("1");
  const { userRole } = useSelector((state) => state.userLogin);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const labelStyle = {
    color: "#ff8000",
    textTransform: "none",
    letterSpacing: 1,
    fontWeight: "bold",
  };

  return (
    <Grid container item xs={12} sx={{ marginTop: "-10px" }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="custom tabs"
        sx={{
          margin: "10px",
          width: "100%",
          [`& .${tabsClasses.indicator}`]: {
            backgroundColor: "#003366",
            borderTop: "1px solid #003366",
          },
        }}
      >
        <Tab value="1" label="Screens" style={labelStyle} />
        <Tab value="2" label="Contents" style={labelStyle} />
        {
          userRole === "admin" && <Tab value="3" label="Integrations" style={labelStyle} />
        }
      </Tabs>
      {value === "1" && <ScreenTable />}
      {value === "2" && <ContentTable />}
      {value === "3" && <IntegrationList />}
    </Grid>
  );
};

export default CustomTabs;
